import React, { useState, useEffect } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	TextField,
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";

const EditMessageModal = ({ open, onClose, onConfirm, initialValue }) => {
	const [message, setMessage] = useState(initialValue || "");

	// Actualizar el mensaje cuando cambie el initialValue
	useEffect(() => {
		setMessage(initialValue || "");
	}, [initialValue]);

	const handleClose = () => {
		setMessage(initialValue || "");
		onClose();
	};

	const handleConfirm = () => {
		onConfirm(message);
		handleClose();
	};

	return (
		<Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
			<DialogTitle>Edicion de mensaje</DialogTitle>
			<DialogContent>
				<TextField
					autoFocus
					multiline
					rows={4}
					margin="dense"
					label="Mensaje"
					type="text"
					fullWidth
					value={message}
					onChange={(e) => setMessage(e.target.value)}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} color="default">
					Cancelar
				</Button>
				<Button onClick={handleConfirm} color="primary">
                    confirmar
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default EditMessageModal; 